"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _EventList_1 = require("./_EventList");
var _NotificationConfigurationFilter_1 = require("./_NotificationConfigurationFilter");
exports._TopicConfiguration = {
    type: "structure",
    required: ["TopicArn", "Events"],
    members: {
        Id: {
            shape: {
                type: "string"
            }
        },
        TopicArn: {
            shape: {
                type: "string"
            },
            locationName: "Topic"
        },
        Events: {
            shape: _EventList_1._EventList,
            locationName: "Event"
        },
        Filter: {
            shape: _NotificationConfigurationFilter_1._NotificationConfigurationFilter
        }
    }
};
//# sourceMappingURL=_TopicConfiguration.js.map